import type { Levels } from './loadEconomy'

export interface LevelInfo {
  /** 1..maxLevel. */
  level: number
  /** XP earned since reaching `level`. */
  xpIntoLevel: number
  /** XP needed to go from `level` to `level + 1`; 0 at `maxLevel`. */
  xpForNext: number
}

/** XP to go from level `level` to `level + 1` (D-038): `baseXp + stepXp × (level − 1)`. */
export function xpToNext(level: number, levels: Levels): number {
  return levels.baseXp + levels.stepXp * (level - 1)
}

/**
 * Level for a running XP total. At `maxLevel` the level stops and `xpIntoLevel` keeps counting
 * the XP past that level's threshold.
 */
export function levelForXp(totalXp: number, levels: Levels): LevelInfo {
  let rest = Math.max(0, Math.floor(totalXp))
  let level = 1
  while (level < levels.maxLevel) {
    const need = xpToNext(level, levels)
    if (rest < need) return { level, xpIntoLevel: rest, xpForNext: need }
    rest -= need
    level++
  }
  return { level, xpIntoLevel: rest, xpForNext: 0 }
}

/**
 * Cumulative XP needed to reach each level: index `L − 1` is the total for level `L`
 * (`[0, 200, 450, …]`, length `maxLevel`). Sent to `record_match` so SQL never repeats the curve.
 */
export function levelThresholds(levels: Levels): number[] {
  const out = [0]
  for (let level = 1; level < levels.maxLevel; level++) {
    out.push(out[level - 1]! + xpToNext(level, levels))
  }
  return out
}
